<template>
  <!-- prettier-ignore -->
  <n-button v-rw type="error" :custom-icon="value ? 'fas fa-lock' : 'fa fa-lock-open'" :text="value ? 'unlock' : 'lock'" ghost style="width: 74px;" @on-click="onClick" />
</template>

<script>
export default {
  name: 'NbLock',
  props: {
    value: Boolean,
  },
  methods: {
    onClick() {
      let v = !this.value;
      this.$emit('input', v);
      this.$emit('on-change', v);
    },
  },
};
</script>
